<template>
  <div
    class="generalInfoError container"
  >
    <img
      src="@/assets/img/error-not-found.svg"
      alt="Error Not Found"
      class="generalInfoError__image"
    >
    <div class="generalInfoError__title">
      Oh, não!
    </div>
    <div class="generalInfoError__text">
      A página não foi encontrada.
    </div>
    <div class="generalInfoError__footer">
      <ButtonComponent
        btn-style="secondary"
        :to="{ name: 'Home' }"
        text="Ir para o início"
      />
    </div>
  </div>
</template>

<script>
import ButtonComponent from '@/components/common/ButtonComponent.vue';

export default {
  name: 'ErrorNotFound',
  components: {
    ButtonComponent
  },
  metaInfo() {
    return {
      title: 'Página não encontrada'
    };
  }
};
</script>

<style lang="scss" scoped>
  .generalInfoError {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    margin: 4rem 0;

    &__image {
      max-height: 400px;
    }

    &__title {
      font-size: $text-2xl;
      font-family: Montserrat-Bold, Arial, Helvetica, sans-serif;
      text-align: center;
    }

    &__text {
      width: 100%;
      margin-top: 1rem;
      font-size: $text-base;
      font-family: Montserrat-Regular, Arial, Helvetica, sans-serif;
      text-align: center;

      @include screen (desktop-up) {
        width: 40%;
      }
    }

    &__footer {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 3rem;

      &-button {
        margin-top: 2rem;
        display: flex;
        justify-content: center;
        width: 14rem;
        align-items: center;
        padding: 0.8rem;
        border-radius: $radius-lg;
        top: 0;

        &-text {
          font-weight: $font-bold;
          font-size: $text-sm;
        }
      }
    }
  }
</style>
